const TASK_SOURCE_HOSTS = new Set([
  'planner.cloud.microsoft',
  'to-do.live.com',
]);

/**
 * Accept only known HTTPS task-provider links before exposing or opening them.
 * Task URLs originate outside the browser trust boundary, so `noopener` alone
 * is not sufficient protection against executable or lookalike URLs.
 */
export function safeTaskSourceUrl(
  rawUrl: string | null | undefined,
): string | null {
  if (!rawUrl) return null;
  try {
    const url = new URL(rawUrl);
    if (
      url.protocol !== 'https:' ||
      url.username ||
      url.password ||
      !TASK_SOURCE_HOSTS.has(url.hostname.toLowerCase())
    ) {
      return null;
    }
    return url.toString();
  } catch {
    return null;
  }
}
